export default __webpack_public_path__ + "static/media/bat.766db311.png";